import React from "react";
import Typograpy from "../../../../components/ui/Typography";
import Button from "../../../../components/ui/Button";
import { Trash, User2Icon } from "lucide-react";
import { styles } from "./styles";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { remittanceActions } from "../../state/remittanceSlice";
import { remittanceApi } from "../../api/remittanceApi";
import { AppStrings, logApiErrorToSentry } from "../../utils";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { ConfirmCancelModal } from "../../components/modal";
import MixpanelConfig from "../../../../constants/MixpanelConfig";

const RecipientDetails = ({ recipientData, loading, error }: any) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const authState = useAppSelector((state) => state.auth);
  const remitterState = useAppSelector((state) => state.remittance);
  const { remitter, recipient } = useAppSelector((state) => state.remittance);

  const deleteRecipientById = async (recipientId: string) => {
    try {
      dispatch(remittanceActions.setDeleteRecipient({ loading: true, error: null }));
      const response = await remittanceApi.getDeleteRecipientByRemitter({ remitterId: remitter?.selectedRemitter?.userKey,recipientId: recipientId});
      dispatch(remittanceActions.setModalType(""));
      dispatch(remittanceActions.setDeleteRecipient({ loading: false, error: null }));
      dispatch(remittanceActions.setRecipientListState({ reload: true }));
      let successMessage = response?.data?.message || response?.data;
      toast.success(successMessage == "User recipient deactivated successfully" ? "Recipient has been successfully deleted" : successMessage);
    } catch (err: any) {
      const errorMsg = err?.response?.data?.error?.type || err?.response?.error?.type || err?.response?.error || AppStrings.GENERIC_ERROR;
      toast.error(errorMsg);
      dispatch(remittanceActions.setDeleteRecipient({ loading: false, error: errorMsg }));
      logApiErrorToSentry(err, "deleteRecipientById");
    }
  };

  if (error) {
    return (
      <div className="p-4 flex justify-center items-center">
        <Typograpy tagType="div" text={error} className="text-sm font-normal text-red-100" />
      </div>
    );
  }

  if (loading) {
    return (
      <div className="p-4 flex justify-center items-center">
        <div className="animate-spin h-6 w-6 border-2 border-t-blue-500 rounded-full" />
      </div>
    );
  }

  return (
    <div className={styles.recipientDetails.container}>
      <div className={styles.recipientDetails.grid}>

        {/* LEFT SECTION */}
        <div className={styles.recipientDetails.leftCol}>

          <div className={styles.recipientDetails.rowWide}>
            <Typograpy tagType="div" text="Recipient Address: " className="text-sm font-normal text-black" />
            <Typograpy
              tagType="div"
              text={[
                recipientData?.recipientAddress?.trim(),
                recipientData?.city?.trim(),
              ].filter(Boolean).join(", ")}
              className="text-sm font-normal text-black text-wrap"
            />
          </div>

          <div className={styles.recipientDetails.row}>
            <Typograpy tagType="div" text="Bank name: " className="text-sm font-normal text-black" />
            <Typograpy tagType="div" text={recipientData?.bankName} className="text-sm font-normal text-black" />
          </div>

          <div className={styles.recipientDetails.row}>
            <Typograpy tagType="div" text="IBAN: " className="text-sm font-normal text-black" />
            <Typograpy tagType="div" text={recipientData?.ibanCode} className="text-sm font-normal text-black" />
          </div>

          <div className={styles.recipientDetails.row}>
            <Typograpy tagType="div" text="SWIFT: " className="text-sm font-normal text-black" />
            <Typograpy tagType="div" text={recipientData?.swiftCode} className="text-sm font-normal text-black" />
          </div>

          <div className={styles.recipientDetails.row}>
            <Typograpy tagType="div" text="Reference No: " className="text-sm font-normal text-black" />
            <Typograpy tagType="div" text={recipientData?.refrence} className="text-sm font-normal text-black" />
          </div>

        </div>

        {/* RIGHT SECTION */}
        <div className={styles.recipientDetails.rightCol}>

          <div>
            <Button
              bgColor="bg-[#006EFF]"
              fontStyle={{
                fontFamily: "font-Inter",
                fontSize: "text-sm",
                fontWeight: "font-normal",
                fontColor: "text-white",
              }}
              className={styles.recipientDetails.primaryBtn}
              onClickHandler={() => {
                dispatch(remittanceActions.resetDocumentsState());
                dispatch(remittanceActions.setSelectedRecipient(recipientData));
                dispatch(remittanceActions.setActiveStepNumber(4));
                dispatch(remittanceActions.resetDocumentsState());
                navigate("/send/documents");
                MixpanelConfig.trackEvent(MixpanelConfig.eventNames.New_Recipient_Select, {
                  authState: authState,
                  remitterState: remitterState,
                  recipientData: recipientData
                });
              }}
            >
              <div className="flex items-center gap-1">
                <User2Icon width={15} height={15} />
                {"Select Recipient"}
              </div>
            </Button>
            <div className="mt-3" />
            <Button
              bgColor="bg-blue-50"
              fontStyle={{
                fontFamily: "font-Inter",
                fontSize: "text-sm",
                fontWeight: "font-normal",
                fontColor: "text-red-500",
              }}
              className={styles.recipientDetails.deleteBtn}
              onClickHandler={() => dispatch(remittanceActions.setModalType("DELETE_RECIPIENT"))}
            >
              <div className={styles.recipientDetails.deleteBtnText}>
                <Trash width={12} height={12} className="text-red-500" />
                {"Delete Recipient"}
              </div>
            </Button>
          </div>

        </div>

      </div>
      <ConfirmCancelModal
        visible={remitterState?.modalType === "DELETE_RECIPIENT"}
        title={AppStrings.DELETE_RECIPIENT_MODAL.TITLE}
        description={AppStrings.DELETE_RECIPIENT_MODAL.DESCRIPTION}
        onConfirm={() => {
          deleteRecipientById(recipientData?.id);
        }}
        onClose={() => {
          dispatch(remittanceActions.setModalType(""));
        }}
        loading={recipient?.deleteRecipient?.loading}
        disabled={recipient?.deleteRecipient?.loading}
      />
    </div>
  )
};

export default RecipientDetails;
